import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h2>
              <span>Industry-Specific</span> Cross-Platform App Development
            </h2>
            <p>
              Navigate the unique landscape of your industry with our
              specialized cross-platform app development services. We craft
              solutions that intricately align with the requirements of your
              sector, ensuring your app not only meets industry benchmarks but
              surpasses expectations.
            </p>
            <p>
              TekRevol excels in cross-platform app development across various
              sectors, delivering bespoke solutions for optimal performance
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Build Your Cross-Platform App Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="offset-lg-3 offset-md-3  my-auto"
          >
            <div className="industry_scroll">
              <h3>Business & Corporate</h3>
              <h3>Healthcare</h3>
              <h3>Music</h3>
              <h3>IT Staff Augmentation</h3>
              <h3>Logistics</h3>
              <h3>Retail</h3>
              <h3>Automotive</h3>
              <h3>On-Demand</h3>
              <h3>E-commerce</h3>
              <h3>Real Estate</h3>
              <h3>Entertainment </h3>
              <h3>Education</h3>
              <h3>Fintech</h3>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industryusa;
